import React, { PureComponent } from 'react';
import { Icon } from 'react-fa';

class Service extends PureComponent {

  handlerRemove() {
    const { index, handlerRemove } = this.props;
    handlerRemove(index)
  }

  render() {
    const { handlerChange, service } = this.props;
    const hasService = !!service;

    return (
      <div className="planet-service">
        {
          hasService ?
            (<div className="planet-service__service">
              <div className="planet-service__img">
                <img src={service.imageUrl}/>
              </div>
              <div className="planet-service__title" dangerouslySetInnerHTML={{ __html: service.title }}/>
            </div>)
            :
            (<div className="planet-service__empty">
              <Icon name="picture-o"/>
              <h3>NEW SERVICE</h3>
            </div>)
        }
        <div className="planet-service__actions">
          {
            hasService && <button
              onClick={this.handlerRemove.bind(this)}
              className="btn btn-primary btn-remove"
              type="button">REMOVE</button>
          }

          {
            hasService && <button
              onClick={handlerChange}
              className="btn btn-primary"
              type="button">CHANGE</button>
          }

          {
            !hasService && <button
              onClick={handlerChange}
              className="btn btn-primary"
              type="button">ADD</button>
          }
        </div>
      </div>
    );
  }
}

Service.propTypes = {};
Service.defaultProps = {};

export default Service;



// WEBPACK FOOTER //
// ./src/components/Render/Service/Service.js